import { render, staticRenderFns } from "./ComponentPageHeaderLabel.vue?vue&type=template&id=5d43fb10&"
var script = {}
import style0 from "./ComponentPageHeaderLabel.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports